<template>
    <v-container v-if="reportSettings" class="pa-5" fluid>
        <ImagePreviewDialog
            :is-open="imagePreviewDialog"
            :max-width="1200"
            :file-preview-uri="filePreviewURI"
            @on-close="closeImagePreviewDialog"
        />
        
        <ReportMaterialReservationDialog
            :is-open="materialReservationDialog"
            :object-number="task.primaryNumber"
            :production-site-id="reportSettings.workspace.id"
            @on-close="closeMaterialReservationDialog"
        />
        <page-title>Nowy raport - {{ processName }} na {{ machineName }}</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="10" offset-xl="1">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-btn
                                v-if="hasTaskComments && !areTaskCommentsVisible"
                                color="error"
                                outlined
                                x-large
                                block
                                class="mb-3"
                                data-sentry-label="Pokaż uwagi do zadania"
                                @click="areTaskCommentsVisible = true"
                            >
                                Pokaż uwagi do zadania
                            </v-btn>

                            <v-alert
                                v-if="hasTaskComments"
                                v-model="areTaskCommentsVisible"
                                type="error"
                                prominent
                                dark
                                elevation="2"
                            >
                                <span class="text-uppercase">Uwagi do zadania</span>

                                <v-divider
                                    class="my-4"
                                    color="error"
                                />

                                <div v-for="(comment, index) in taskComments" :key="index">
                                    {{ comment.value }}
                                </div>

                                <v-divider
                                    class="my-4"
                                    color="error"
                                />
                                <v-btn
                                    depressed
                                    outlined
                                    large
                                    block
                                    class="mt-5"
                                    data-sentry-label="Potwierdzenie zapoznania się z komentarzem"
                                    @click="confirmTaskCommentsRead()"
                                >
                                    Potwierdzam zapoznanie się z komentarzem
                                </v-btn>
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <v-btn
                                block
                                color="warning"
                                dark
                                data-sentry-label="Zgłoś zapotrzebowanie materiału - druk"
                                @click="showMaterialReservationDialog"
                            >
                                ZGŁOŚ ZAPOTRZEBOWANIE MATERIAŁU
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Parametry</v-toolbar-title>
                                            </v-toolbar>
                                            <v-divider />
                                            <v-card-text>
                                                <v-container class="pa-0">
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-select
                                                                v-model="currentPlate"
                                                                disabled
                                                                :items="plates"
                                                                label="Montaż"
                                                                item-value="id"
                                                                return-object
                                                                outlined
                                                                hide-details
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                    Montaż {{ data.item.plateNumber }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    Montaż {{ data.item.plateNumber }}
                                                                </template>
                                                            </v-select>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <table class="table table--simple">
                                                                <tbody>
                                                                    <tr>
                                                                        <th>Nr zlecenia:</th>
                                                                        <td>{{ task.primaryNumber }}</td>
                                                                    </tr>
                                                                    <tr v-for="(item) in taskParameters" :key="item.id">
                                                                        <th>
                                                                            {{ item.name | capitalize }}:
                                                                        </th>
                                                                        <td>{{ parseEmptyValue(item.value) }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-container class="pa-0">
                                <v-row align="center">
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-text>
                                                <v-container class="pa-0">
                                                    <v-row justify="center">
                                                        <v-col cols="12">
                                                            <div class="qr-code-container">
                                                                <img src="@/assets/images/qr/qr-tracking-start.svg" class="qr-code hidden-sm-and-down">
                                                                <v-row justify="space-between">
                                                                    <v-col cols="8">
                                                                        <v-btn
                                                                            color="success"
                                                                            data-sentry-label="Rozpocznij/Rozpocznij przyrząd"
                                                                            @click="createReport"
                                                                        >
                                                                            {{ reportStartButtonText }}
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-text class="pb-0">
                                                <v-container class="pa-0">
                                                    <v-row>
                                                        <v-col 
                                                            cols="12"
                                                            class="d-flex align-center"
                                                            :class="{
                                                                'justify-space-between': isReportItemPlateAB,
                                                                'justify-center': !isReportItemPlateAB,
                                                            }"
                                                        >
                                                            <v-btn
                                                                color="info"
                                                                style="pointer-events: none"
                                                                @click.prevent
                                                            >
                                                                TRYB DRUKU: {{ reportItemPlatesLabel }} 
                                                            </v-btn>
                                                            <v-btn
                                                                v-if="isReportItemPlateAB"
                                                                color="purple darken-1"
                                                                data-sentry-label="TRYB AWARYJNY"
                                                                dark
                                                                :loading="updateReportItemPlatesLoading"
                                                                @click="updateReportItemPlates"
                                                            >
                                                                TRYB AWARYJNY
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="justify-space-between align-center">
                                                        <v-col
                                                            v-for="(plate, index) in reportItemPlates"
                                                            :key="index"
                                                            class="d-flex pb-0"
                                                            :class="{
                                                                'col-lg-6 col-xs-6': reportItemPlates.length > 1,
                                                                'justify-end': reportItemPlates.length > 1 && index == 1,
                                                                'justify-center col-lg-12 col-xs-12': reportItemPlates.length == 1,
                                                            }"
                                                        >
                                                            <v-checkbox
                                                                v-model="printSideTypesChecked[plate.printSideType]"
                                                                class="ma-0"
                                                                :color="plate.isFullReported ? 'success' : 'primary'"
                                                                :readonly="manageCheckboxReadonly"
                                                                @change="manageCheckboxChecked(plate)"
                                                            >
                                                                <template #label>
                                                                    <span :class="{'green--text': plate.isFullReported}">
                                                                        Raportowanie strony {{ plate.printSideType }}
                                                                    </span>
                                                                </template>
                                                            </v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col>
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Podgląd</v-toolbar-title>
                                            </v-toolbar>

                                            <v-divider />

                                            <v-card-text>
                                                <v-container class="pa-0">
                                                    <v-row v-viewer>
                                                        <template v-if="hasPreviews">
                                                            <v-col v-for="(components, key, index) in currentPlatePreviews" :key="index">
                                                                <h3 class="text-subtitle-1 my-2">
                                                                    {{ key }}
                                                                </h3>
                                                                <v-row>
                                                                    <v-col
                                                                        v-for="(image, previewIndex) in components"
                                                                        :key="previewIndex"
                                                                        cols="6"
                                                                    >
                                                                        <div
                                                                            class="fill-width text-h6 d-flex align-center justify-center success white--text"
                                                                        >
                                                                            {{ image.side == 1 ? 'A' : 'B' }}
                                                                        </div>
                                                                        <img
                                                                            :src="taskPreviewURI(image)"
                                                                            class="report-preview-img"
                                                                            :alt="`Podgląd ${image.side == 1 ? 'A' : 'B'}`"
                                                                        >
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </template>
                                                        <v-col v-else cols="12">
                                                            <v-alert
                                                                type="info"
                                                                text
                                                                border="left"
                                                            >
                                                                Brak podglądów.
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row>
                        <NextScheduledTasks
                            :limit="isOffsetPrintSite ? 3 : 1"
                            :is-printing="isOffsetPrintSite" 
                        />
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ImagePreviewDialog from '@/components/common/ImagePreviewDialog'
import PageTitle from '@/components/common/PageTitle'
import ReportMaterialReservationDialog from './ReportMaterialReservationDialog'
import { errorHandler } from '@/utils/errorHandler'
import { sortBy } from 'lodash'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import { apiConfig } from '@/config'
import parse from '@/mixins/parse'
import store from '@/store'
import { groupBy } from 'lodash'
import { trim } from 'lodash'
import NextScheduledTasks from '../Common/NextScheduledTasks.vue'

export default {
    name: 'CreatePrintReport',
    components: {
        PageTitle,
        ImagePreviewDialog,
        NextScheduledTasks,
        ReportMaterialReservationDialog
    },
    mixins: [ parse, dateFormatter, tooltipDelay ],
    beforeRouteEnter(to, from, next) {
        if (typeof to.params?.task !== 'undefined') {
            next(vm => {
                vm.task = to.params.task
                vm.currentPlate = to.params.plate

                const plate_ab = vm.task.reportItemPlates.find(item =>
                    item.printSideType === 'AB' &&
                    item.plateNumber == vm.currentPlate.plateNumber &&
                    item.emergencyMode == false
                )

                if (plate_ab) {
                    vm.currentPlate = plate_ab
                } else {
                    let plate_b = vm.task.reportItemPlates.find(item =>
                        item.printSideType === 'B' && item.plateNumber == vm.currentPlate.plateNumber
                    )

                    if (!plate_b || plate_b.isFullReported) {

                        let plate_a = vm.task.reportItemPlates.find(item =>
                            item.printSideType === 'A' && item.plateNumber == vm.currentPlate.plateNumber
                        )

                        if (plate_a) {
                            vm.currentPlate = plate_a
                        }
                    } else {
                        vm.currentPlate = plate_b
                    }
                }

                vm.carouselIndexes = new Array(groupBy(vm.currentPlate.previews, 'type').length).fill(0)
                vm.$store.dispatch('toggleCircularLoader', false)
            })
        } else {
            this.$store.dispatch('toggleCircularLoader', false)
            next({ name: 'reportsReporting' })
        }
    },
    data() {
        return {
            task: {
                type: {},
                typeId: null,
                reportItemPlates: [],
                primaryNumber: ''
            },
            currentPlate: {
                plateNumber: null,
                previews: [],
                reportItemPlateParameters: [],
            },
            printSideTypesChecked: {
                B: true,
                A: true,
                AB: true,
            },
            updateReportItemPlatesLoading: false,
            areTaskCommentsVisible: true,
            scheduledTasks: [],
            carouselIndexes: [],
            imagePreviewDialog: false,
            filePreviewURI: null,
            materialReservationDialog: false,
            actionLoading: {
                scheduledTasks: false,
            },
            printHeaders: [
                {
                    text: 'Nr zlecenia',
                    value: 'procNumber',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Montaż',
                    value: 'procPlateNumber',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Strona', 
                    value: 'procTaskPage', 
                    align: 'center', 
                    sortable: false
                },
                {
                    text: 'Sposób druku',
                    value: 'printMethod',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Rodzaj surowca',
                    value: 'paper',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Format surowca',
                    value: 'format',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Nakład brutto',
                    value: 'procTaskQuantity',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Zaplanowany start',
                    value: 'procTaskStartTime',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Czas druku',
                    value: 'procTaskDuration',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Kolorystyka str. A',
                    value: 'coloursPageA',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Kolorystyka str. B',
                    value: 'coloursPageB',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Lakier str. A',
                    value: 'varnishSideA',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Lakier str. B',
                    value: 'varnishSideB',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Liczarka (co ile arkuszy)',
                    value: 'inserterBatch',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Status materiałów',
                    value: 'materialStatus',
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        processName() {
            return this.reportSettings?.process?.name || ''
        },
        machineName() {
            return this.reportSettings?.machine?.name || ''
        },
        userId() {
            return this.$store.state.user.userId
        },
        reportStartButtonText() {
            return this.reportSettings.workspace.makeReadyRequired === true ? 'Rozpocznij przyrząd': 'Rozpocznij'
        },
        reportItemPlates() {
            const filtered = this.task.reportItemPlates.filter(item => {
                return item.plateNumber === this.currentPlate.plateNumber
            })

            if (filtered.some(item => item.printSideType === 'AB' && !item.emergencyMode)) {
                return filtered.filter(item => item.printSideType === 'AB')
            }

            return filtered.filter(item => item.printSideType !== 'AB')
        },
        isReportItemPlateAB() {
            return this.reportItemPlates.some(item => {
                return item.printSideType === 'AB'
            })
        },
        reportSettings() {
            return this.$store.state.reports.reporting.reportSettings
        },
        taskParameters() {
            const sortedList = [
                'sposób druku',
                'papier',
                'format A',
                'format B',
                'nakład netto',
                'makulatura na przyrząd',
                'makulatura na bieg',
                'czas przyrządu',
                'czas biegu',
                'kolorystyka strona A',
                'kolorystyka strona B',
                'wzór kolorystyczny',
                'lakier strona A',
                'lakier strona B',
                'liczenie arkuszy co',
            ]

            let filteredList = this.currentPlate.reportItemPlateParameters.filter(item => {
                return sortedList.includes(trim(item.name))
            })

            return sortBy(filteredList, item => {
                return sortedList.indexOf(trim(item.name))
            })
        },
        plates() {
            return this.reportItemPlates.filter(item => !item.isFullReported)
        },
        taskComments() {
            return this.currentPlate.reportItemPlateParameters.filter(item => {
                return item.name === 'uwagi'
            })
        },
        hasTaskComments() {
            return this.taskComments.length
        },
        hasPreviews() {
            return this.currentPlate?.previews && this.currentPlate.previews.length > 0
        },
        currentPlatePreviews() {
            return groupBy(this.currentPlate.previews, 'type')
        },
        reportItemPlatesLabel() {
            if (this.isReportItemPlateAB) {
                return 'Dwustronny SW'
            }

            return this.reportItemPlates.length > 1 ? 'Dwustronny' : 'Jednostronny'
        },
        isSomeItemPlateFullReported() {
            return this.reportItemPlates.some(item => item.isFullReported)
        },
        manageCheckboxReadonly() {
            return this.reportItemPlates.length === 1 || this.isSomeItemPlateFullReported
        },
        workspaceSettings() {
            const workspace = localStorage.getItem('workspace')

            return JSON.parse(workspace)
        },
        isOffsetPrintSite() {
            if (!this.workspaceSettings.workspaceTypeId) return

            return this.workspaceSettings.workspaceTypeId === 7
        },
    },
    watch: {
        reportSettings: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.machine && newVal.process) {
                    this.manageCheckboxChecked()
                    this.getAdditionalActionProcessProductionSite()
                }
            }
        },
        currentPlate: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.setCurrentPlateAsChecked()
                }
            }
        }
    },
    methods: {
        showOrdersListDialog() {
            this.$store.commit('reports/reporting/setOrdersListDialog', true)
        },
        close() {
            this.$router.push({
                name: 'reportsReporting',
                params: {
                    machine: this.reportSettings.machine,
                    process: this.reportSettings.process
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        confirmTaskCommentsRead() {
            this.areTaskCommentsVisible = false
        },
        isWarehouseHasReportedStatus(item) {
            return item.wareHouseStatus !== 'NOT_REPORTED' && item.rubberStatus !== false && item.CTPStatus !== false
        },
        async getScheduledTasks(machineCode) {
            this.actionLoading.scheduledTasks = true

            return await store.dispatch('reports/getScheduledTasks', {
                machineCode,
                limit: 3,
                productionSiteId: this.reportSettings?.workspace?.id
            })
                .then(response => {
                    this.scheduledTasks = response.data.results
                })
                .catch(error => {
                    throw error
                })
                .finally(() => {
                    this.actionLoading.scheduledTasks = false
                })
        },
        taskPreviewURI(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image.path}`
        },
        showFilePreviewDialog(image) {
            this.filePreviewURI = this.taskPreviewURI(image)
            this.imagePreviewDialog = true
        },
        closeImagePreviewDialog() {
            this.imagePreviewDialog = false
        },
        showMaterialReservationDialog() {
            this.materialReservationDialog = true
        },
        closeMaterialReservationDialog() {
            this.materialReservationDialog = false
        },
        setCurrentPlateAsChecked() {
            if (this.isSomeItemPlateFullReported) {
                this.printSideTypesChecked.A = true
                this.printSideTypesChecked.B = true

                return
            }

            if (this.currentPlate.printSideType == 'A') {
                this.printSideTypesChecked.A = true
                this.printSideTypesChecked.B = false
            } else if (this.currentPlate.printSideType == 'B') {
                this.printSideTypesChecked.B = true
                this.printSideTypesChecked.A = false
            }
        },
        manageCheckboxChecked(plate) {
            this.findAndSetAppropriateCurrentPlate()

            if (plate) {
                if (plate.printSideType === 'A') {
                    this.printSideTypesChecked.B = !this.printSideTypesChecked.A
                } else if (plate.printSideType === 'B') {
                    this.printSideTypesChecked.A = !this.printSideTypesChecked.B
                }

                if (plate.printSideType !== 'AB') {
                    const sideToSelect = this.printSideTypesChecked.A ? 'A' : 'B'

                    this.setCurrentPlate(sideToSelect, plate.plateNumber)
                }
            }
            this.setCurrentPlateAsChecked()
        },

        findAndSetAppropriateCurrentPlate() {
            // priority order: AB, B, A
            const plateTypes = ['AB', 'B', 'A']
            const plateNumber = this.currentPlate.plateNumber

            for (const side of plateTypes) {
                const plate = this.findPlate(side, plateNumber)

                if (plate) {
                    this.currentPlate = plate

                    return
                }
            }
        },
        findPlate(side, plateNumber) {
            return this.task.reportItemPlates.find(item => 
                item.printSideType === side && 
                item.plateNumber === plateNumber && 
                (
                    (side === 'AB' && item.emergencyMode === false) ||
                    (side !== 'AB' && item.isFullReported === false)
                )
            )
        },
        setCurrentPlate(side, plateNumber) {
            const plate = this.findPlate(side, plateNumber)

            if (plate) {
                this.currentPlate = plate
            }
        },
        updateReportItemPlates() {
            this.updateReportItemPlatesLoading = true

            this.$store.dispatch('reports/updateReportItemPlates', {
                id: this.currentPlate.id,
                emergencyMode: true,
            })
                .then((response) => {
                    this.task.reportItemPlates.find(item => {
                        return item.id === response.id
                    }).emergencyMode = true

                    this.manageCheckboxChecked(this.task.reportItemPlates.find(item => {
                        return item.printSideType === 'B' && item.plateNumber == response.plateNumber
                    }))
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.updateReportItemPlatesLoading = false
                })
        },
        getAdditionalActionProcessProductionSite() {
            this.$store.dispatch('reports/getAdditionalActionProcessProductionSite', {
                productionSiteId: this.reportSettings.workspace.id,
                processId: this.reportSettings.process.id
            })
                .then(response => {
                    this.additionalActionsProcessProductionSite = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createReport() {
            this.$store.dispatch('toggleCircularLoader', true)
            this.$store.dispatch('reports/createReport', {
                processCodeId: 1,
                objectId: this.currentPlate.id,
                objectType: this.currentPlate.objectType,
                objectNumber: this.task.primaryNumber,
                plateNumber: this.currentPlate.plateNumber || 1,
                machine: this.reportSettings.machine.id,
                process: this.reportSettings.process.id,
                user: this.userId,
                outOfSequenceCodeId: this.outOfSequenceCodeId,
                plannedDuration: this.currentPlate.duration,
                currentlyReportedQuantity: 0,
                productionSiteId: this.reportSettings.workspace.id,
                additionalActionProcessProductionSites: JSON.parse(JSON.stringify(this.additionalActionsProcessProductionSite)),
                startMakeReady: this.reportSettings.workspace.makeReadyRequired === true,
                reportPalletsData: this.pallets
            })
                .then(response => {
                    this.$router.push(
                        {
                            name: 'reportsReportingReport',
                            params: {
                                id: response.id,
                                report: response
                            }
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$store.dispatch('toggleCircularLoader', false)
                })
        },
    },
}
</script>

<style scoped>
.report-preview-img {
    max-height: 350px;
    width: 100%;
    object-fit: contain;
    cursor: pointer;
    display: block;
}
</style>